import React from 'react';
import Main from './main';

const IndexProductsCarts = props => {
  const [productsCarts, setProductsCarts] = React.useState(
    props.products_carts
  );
  const [company] = React.useState(props.company);

  return (
    <Main
      props={props}
      productsCarts={productsCarts}
      setProductsCarts={setProductsCarts}
      company={company}
      companies_user={props.companies_user}
    />
  );
};

export default IndexProductsCarts;
